export const golangData = [
    {
    para1: "IStellar brings the market-driven Golang development service to offer robust and modular web development with great efforts of our Golang developers",
    para2: "Our offshore Golang programmers provide quick deployment of Golang application development projects and reliable support for ongoing projects. Hence, when you are looking for a specific requirement in your niche, our Golang developers help you to fulfill your requirements",
    ul: [
        {li: "VueJS development",
        path: "/services/vuejs-development"},
        {li: "AngularJS development",
        path: "/services/angular-development"},
        {li: "Angular development",
        path: "services/angular-development"},
        {li: "NodeJS API development",
        path: "/services/nodejs-development"},
        {li: "D3.JS Data Visualization",
        path: "/"},
        {li: "React Native Mobile App Development",
        path: "/services/reactjs-development"},
    ]
}
]
export const golangPara = [
    "Golang, was specifically designed to build simple, efficient, and reliable software. The intention was to get the perfect balance between performance and control, combined with the experience of the developer. Most software development solutions were struggling with clumsiness and slow speed. Golang was a perfect way out of these issues as it makes the process more productive and scalable. The minds behind this programming language are the ones who were tired of cluttered languages with unnecessary elements. These experts were involved in writing, reading, and debugging software systems. Whether you are a multinational company or a startup, the Golang development service will take care of cloud services, IoT, distributed networks, and other backend technologies."
]
export const golangImg = [
    "golang"
]
export const golangServicesPara = [
    "Build reliable, effective, and powerful web API solutions with next-generation open-source programming language- Golang."
]
export const golangCardData = [
    {
        id: 1,
        title: "Custom Golang development",
        content: "Our dedicated remote Golang developers build next-gen enterprise apps for global businesses while ensuring less expensive code maintainability."
    }, {
        id: 2,
        title: "Full-Stack Development with Go",
        content: "Our Golang developers have top-of-the-line expertise in combining the possible number of front-end and back-end technologies like ReactJS, Angular, MongoDB, Strings, Docker, Vuejs, and many more."
    }, {
        id: 3,
        title: "Dedicated Golang Developers",
        content: "Our dedicated Golang web programmers develop and maintain various software including database, scalable system, back-end architecture, server, command-line apps, APIs, web apps etc."
    }, {
        id: 4,
        title: "Golang Support and Maintenance",
        content: "As per the growing demand, it is quite significant to maintain your Golang web applications from time to time. At IStellar, our qualified tech support team will be there at your disposal round the clock to provide you continuous support for your business-critical applications."
    }, {
        id: 5,
        title: "Microservices development",
        content: "Golang fits in the criteria for application extensibility and is well suited for multiprocessor systems and web applications. We can help you build microservices using Golang for better scalability, high quality and performance."
    }, {
        id: 6,
        title: "Consulting and strategy",
        content: "Consultation and strategy are two main stepping stones for businesses to perform. Our Golang consultants will evaluate your concept to help you make the right choices as well as overcome any challenges."
    }
]